document.addEventListener('DOMContentLoaded', async () => {
  const ctx = window.__PRODUCT_LIMIT_CONTEXT__;
  if (!ctx) return;

  const productId = parseInt(ctx.productId, 10);
  const limit = parseInt(ctx.limit, 10);

  if (!limit || limit <= 0) return;

  const form = document.querySelector('form[action*="/cart/add"]');
  const qtyInput = document.querySelector('[data-siyati-qty]');
  const plusBtn = document.querySelector('[data-siyati-plus]');
  const minusBtn = document.querySelector('[data-siyati-minus]');
  const submitBtn = form?.querySelector('button[type="submit"]');

  if (!form || !qtyInput || !submitBtn) {
    console.warn('limite-commandes: éléments introuvables');
    return;
  }

  let existingQty = 0;

  const getCartQty = async () => {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });
    const cart = await res.json();

    return cart.items
      .filter(item => Number(item.product_id) === productId)
      .reduce((sum, item) => sum + item.quantity, 0);
  };

  const getSelectedQty = () => {
    const val = parseInt(qtyInput.value || '1', 10);
    return Number.isNaN(val) || val < 1 ? 1 : val;
  };

  const isOverLimit = () => {
    const selectedQty = getSelectedQty();
    return existingQty + selectedQty > limit;
  };

  const renderState = () => {
    const overLimit = isOverLimit();

    submitBtn.disabled = overLimit;
    submitBtn.style.opacity = overLimit ? '0.5' : '';
    submitBtn.style.cursor = overLimit ? 'not-allowed' : '';
  };

  try {
    existingQty = await getCartQty();
    renderState();
  } catch (err) {
    console.error('limite-commandes: erreur lecture panier', err);
  }

  const delayedRender = () => setTimeout(renderState, 30);

  if (plusBtn) plusBtn.addEventListener('click', delayedRender);
  if (minusBtn) minusBtn.addEventListener('click', delayedRender);
  qtyInput.addEventListener('input', renderState);
  qtyInput.addEventListener('change', renderState);

  form.addEventListener('submit', async (e) => {
    try {
      existingQty = await getCartQty();

      if (isOverLimit()) {
        e.preventDefault();
        e.stopPropagation();

        const selectedQty = getSelectedQty();
        const remaining = Math.max(limit - existingQty, 0);

        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.5';
        submitBtn.style.cursor = 'not-allowed';

        alert(
          remaining <= 0
            ? `Limite atteinte : ${existingQty} déjà dans le panier, maximum ${limit}.`
            : `Vous avez ${existingQty} dans le panier. Il reste ${remaining} possible. Quantité demandée : ${selectedQty}.`
        );

        return false;
      }
    } catch (err) {
      console.error('limite-commandes: erreur contrôle submit', err);
    }
  }, true);
});